import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button, { ButtonVariant } from "./Button";
import { useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
// @ts-ignore
import { useNavigate } from "react-router-dom";
import TitleBar from "./WithfriendsTitleBar";
const NotConnectedScreen = ({ action }) => {
    // TODO - can't seem to abstract this out without React crashing, so we gotta copy and paste it into any relevant file
    let app, redirect = null;
    let navigate = useNavigate();
    try {
        app = useAppBridge();
        redirect = Redirect.create(app);
    }
    catch (e) { }
    const VisitLink = (url, redirectKind = Redirect.Action.APP, isExternal = false) => {
        (redirect ?
            redirect.dispatch(redirectKind, { url: url, newContext: isExternal }) : (isExternal ?
            window.open(url) : (redirectKind == Redirect.Action.APP ?
            navigate(url) :
            window.location.href = url)));
    };
    // TODO - end
    return (_jsxs("div", { className: "w-full flex justify-center", children: [_jsx(TitleBar, { action: action }), _jsxs("div", { className: "w-full my-4 max-w-xl", children: [_jsx("p", { className: "prose prose-xl max-w-none w-full", children: "You're not currently linked to an account on Withfriends." }), _jsx(Button, { variant: ButtonVariant.Salmon, className: "my-4", onClick: () => VisitLink("/link"), children: "Get Started: Link your business to Withfriends" })] })] }));
};
export default NotConnectedScreen;
